import { FC } from 'react';

import { CountryEntity } from 'api/types/entity';
import { LegalClientBodyEntity } from 'api/types/entity/legal/legalClientBody';
import { isFinanceProject, isGlobalProject } from 'config';
import { useFormErrorFocus } from 'hooks';
import { useTranslation } from 'libs/i18n';
import { Stack } from 'libs/ui';
import {
  CitizenshipSection,
  PepConnectionSection,
  TaxResidencySection,
  ReasonAddSection,
  RegistrationAndResidentialAddressSection,
  LegalClientAddHeadPositionSection,
  PlaceOfBirthAndResidentialAddressSection,
} from 'modules/client/common/components/sections';
import {
  CountryRiskProvider,
  CountryRiskRole,
} from 'modules/client/common/feature';

import { PersonalDataSection } from '../sections';

export interface LegalClientAddHeadSectionsProps {
  countriesLoading?: boolean;
  countries: CountryEntity[];
  bodies: LegalClientBodyEntity[];
}

export const LegalClientAddHeadSections: FC<
  LegalClientAddHeadSectionsProps
> = ({ countries, countriesLoading, bodies }) => {
  useFormErrorFocus();

  const isGlobal = isGlobalProject();
  const isFinance = isFinanceProject();

  const { t } = useTranslation();

  return (
    <CountryRiskProvider role={CountryRiskRole.LegalClientHead}>
      <Stack spacing={24}>
        <ReasonAddSection />
        <PersonalDataSection />
        <LegalClientAddHeadPositionSection bodies={bodies} />
        <CitizenshipSection
          countries={countries}
          countriesLoading={countriesLoading}
        />
        <TaxResidencySection
          countries={countries}
          countriesLoading={countriesLoading}
        />
        {isFinance && (
          <RegistrationAndResidentialAddressSection
            countries={countries}
            countriesLoading={countriesLoading}
          />
        )}
        {isGlobal && (
          <PlaceOfBirthAndResidentialAddressSection
            countries={countries}
            countriesLoading={countriesLoading}
          />
        )}
        <PepConnectionSection
          notRequestInformation={isGlobal}
          pepConnectionRelationLabel={t(
            'client.legal.legalClientHead.pepConnection.relation.label'
          )}
        />
      </Stack>
    </CountryRiskProvider>
  );
};
